import { render, staticRenderFns } from "./PluginGenericobjectClef.vue?vue&type=template&id=22c6fe19"
import script from "./PluginGenericobjectClef.vue?vue&type=script&lang=js"
export * from "./PluginGenericobjectClef.vue?vue&type=script&lang=js"
import style0 from "./PluginGenericobjectClef.vue?vue&type=style&index=0&id=22c6fe19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports